import type { EntityState } from '@reduxjs/toolkit';

import { ITask } from '../../tasks/interfaces/ITask';
import { getAllTasks, getEvidenceTasks } from '../../tasks/slice/taskListSlice';
import {
  TaskCategory,
  TaskCategoryMapping,
  TaskTypes,
} from '../../tasks/types/taskTypes';

const TOP_DEFAULT_TASK_ORDER: TaskTypes[] = [
  TaskTypes.DECISION,
  TaskTypes.RULE_RESULTS,
  TaskTypes.OVERVIEW,
];

/** Segments aligned with Detail.tsx vertical order. Shared by LeftSidebar. */
export function getCaseDetailNavTaskSegments(taskList: EntityState<ITask>) {
  const all = getAllTasks(taskList);
  const notesTask = all.find(
    t => TaskCategoryMapping[t.taskType] === TaskCategory.NOTES_TASK,
  );

  const defaultTasks = all.filter(
    t => TaskCategoryMapping[t.taskType] === TaskCategory.DEFAULT_TASK,
  );
  const orderedTops = TOP_DEFAULT_TASK_ORDER.map(type =>
    defaultTasks.find(t => t.taskType === type),
  ).filter((t): t is ITask => t !== undefined);
  const remainingDefaults = defaultTasks.filter(
    t =>
      t.taskType !== TaskTypes.DOCTOR_INFO &&
      !TOP_DEFAULT_TASK_ORDER.includes(t.taskType),
  );
  const topDefaultTasks = [...orderedTops, ...remainingDefaults];
  const doctorInfoTask = defaultTasks.find(
    t => t.taskType === TaskTypes.DOCTOR_INFO,
  );

  const evidenceTasks = getEvidenceTasks(taskList);
  const trlAndDisclosureTasks = evidenceTasks.filter(t => {
    const cat = TaskCategoryMapping[t.taskType];
    return (
      cat === TaskCategory.TRL_TASK || cat === TaskCategory.DISCLOSURE_TASK
    );
  });
  const rxAndMibTasks = evidenceTasks.filter(t => {
    const cat = TaskCategoryMapping[t.taskType];
    return cat === TaskCategory.RX_TASK || cat === TaskCategory.MIB_TASK;
  });
  const otherEvidenceTasks = evidenceTasks.filter(t => {
    const cat = TaskCategoryMapping[t.taskType];
    return (
      cat !== TaskCategory.TRL_TASK &&
      cat !== TaskCategory.DISCLOSURE_TASK &&
      cat !== TaskCategory.RX_TASK &&
      cat !== TaskCategory.MIB_TASK
    );
  });

  return {
    topDefaultTasks,
    trlAndDisclosureTasks,
    doctorInfoTask,
    rxAndMibTasks,
    otherEvidenceTasks,
    notesTask,
  };
}
